import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class HeightMeasuredJournalEvent extends JournalEvent {
  static override type = "height-measured-journal-event";

  /**
   * The height in centimeters
   */
  @attr("number") declare height: number;

  static override validations(intl: IntlService) {
    return {
      height: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.height-measured-journal-event.height"
          )
        }),
        validateNumber({
          gt: 20,
          lte: 300,
          description: intl.t(
            "validations.height-measured-journal-event.height"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.height-measured-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "heightMeasuredJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "height-measured-journal-event": HeightMeasuredJournalEvent;
  }
}
